import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import Events from './events/SortOptionsEvents';

import styles from './SortOptions.scss';

function SortOptions(props) {
    const {
        activeSortType = '',
        onComplete = () => undefined,
        onSort = () => undefined,
        searchParams = {},
        sortOptions = {},
        t,
    } = props;

    function onClick(type) {
        onSort(type);
        onComplete();
        Events.sortOptionSelected({
            previousType: activeSortType,
            searchParams,
            type,
        });
    }

    return (
        <div className={styles.sortOptions}>
            {Object.keys(sortOptions).map((type) => (
                <span
                    className={classNames(styles.option, {
                        [styles.activeOption]:
                            type === activeSortType,
                    })}
                    data-id="sortOption"
                    key={type}
                    onClick={() => onClick(type)}
                    role="button"
                >
                    {t(`${type}_tag`)}
                </span>
            ))}
        </div>
    );
}

SortOptions.propTypes = {
    activeSortType: PropTypes.string,
    onComplete: PropTypes.func,
    onSort: PropTypes.func,
    searchParams: PropTypes.object,
    sortOptions: PropTypes.object,
    t: PropTypes.func,
};

export { SortOptions };
export default localize(SortOptions, 'baseApp');
